import { AxiosError } from 'axios';
import { createAsyncAction, ActionType, createAction } from 'typesafe-actions';
import { ErrorModel } from '../../../models/ComnModel';
import {
  initGroup,
  GroupData,
  JoinGroupData,
  AprvGroupData,
  UserGroupData,
  UserGroupState,
  GroupState,
  MainGroupData,
  SelectData
} from '../models/basisGroupModel';

//# 나의 그룹 목록 조회
const MY_LIST_REQUEST = 'basis/group/MY_LIST_REQUEST';
const MY_LIST_SUCCESS = 'basis/group/MY_LIST_SUCCESS';
const MY_LIST_FAILURE = 'basis/group/MY_LIST_FAILURE';

//# 참여 그룹 목록 조회
const JOIN_LIST_REQUEST = 'basis/group/JOIN_LIST_REQUEST';
const JOIN_LIST_SUCCESS = 'basis/group/JOIN_LIST_SUCCESS';
const JOIN_LIST_FAILURE = 'basis/group/JOIN_LIST_FAILURE';

//# 그룹 상세 조회
const GROUP_DETAIL_REQUEST = 'basis/group/GROUP_DETAIL_REQUEST';
const GROUP_DETAIL_SUCCESS = 'basis/group/GROUP_DETAIL_SUCCESS';
const GROUP_DETAIL_FAILURE = 'basis/group/GROUP_DETAIL_FAILURE';

//## 그룹 생성
const GROUP_CREATE_REQUEST = 'basis/group/GROUP_CREATE_REQUEST';
const GROUP_CREATE_SUCCESS = 'basis/group/GROUP_CREATE_SUCCESS';
const GROUP_CREATE_FAILURE = 'basis/group/GROUP_CREATE_FAILURE';

//## 그룹 수정
const GROUP_UPDATE_REQUEST = 'basis/group/GROUP_UPDATE_REQUEST';
const GROUP_UPDATE_SUCCESS = 'basis/group/GROUP_UPDATE_SUCCESS';
const GROUP_UPDATE_FAILURE = 'basis/group/GROUP_UPDATE_FAILURE';

//## 그룹 삭제
const GROUP_DELETE_REQUEST = 'basis/group/GROUP_DELETE_REQUEST';
const GROUP_DELETE_SUCCESS = 'basis/group/GROUP_DELETE_SUCCESS';
const GROUP_DELETE_FAILURE = 'basis/group/GROUP_DELETE_FAILURE';

//## 그룹 전체 조회
const GROUP_LIST_REQUEST = 'basis/group/GROUP_LIST_REQUEST';
const GROUP_LIST_SUCCESS = 'basis/group/GROUP_LIST_SUCCESS';
const GROUP_LIST_FAILURE = 'basis/group/GROUP_LIST_FAILURE';

//# 그룹코드 발급
const GROUP_CREATEID_REQUEST = 'basis/group/GROUP_CREATEID_REQUEST';
const GROUP_CREATEID_SUCCESS = 'basis/group/GROUP_CREATEID_SUCCESS';
const GROUP_CREATEID_FAILURE = 'basis/group/GROUP_CREATEID_FAILURE';

//# 참여가능 그룹 목록 조회
const GROUP_JOINLIST_REQUEST = 'basis/group/GROUP_JOINLIST_REQUEST';
const GROUP_JOINLIST_SUCCESS = 'basis/group/GROUP_JOINLIST_SUCCESS';
const GROUP_JOINLIST_FAILURE = 'basis/group/GROUP_JOINLIST_FAILURE';

//# 나의 그룹 목록 조회
const GROUP_MYLIST_REQUEST = 'basis/group/GROUP_MYLIST_REQUEST';
const GROUP_MYLIST_SUCCESS = 'basis/group/GROUP_MYLIST_SUCCESS';
const GROUP_MYLIST_FAILURE = 'basis/group/GROUP_MYLIST_FAILURE';

//# 그룹 가입처리
const GROUP_JOIN_REQUEST = 'basis/group/GROUP_JOIN_REQUEST';
const GROUP_JOIN_SUCCESS = 'basis/group/GROUP_JOIN_SUCCESS';
const GROUP_JOIN_FAILURE = 'basis/group/GROUP_JOIN_FAILURE';

//# 그룹 가입 탈퇴 / 취소 처리
const GROUP_JOIN_UPDATE_REQUEST = 'basis/group/GROUP_JOIN_UPDATE_REQUEST';
const GROUP_JOIN_UPDATE_SUCCESS = 'basis/group/GROUP_JOIN_UPDATE_SUCCESS';
const GROUP_JOIN_UPDATE_FAILURE = 'basis/group/GROUP_JOIN_UPDATE_FAILURE';

//# 승인요청 조회
const APPROVAL_LIST_REQUEST = 'basis/group/APPROVAL_LIST_REQUEST';
const APPROVAL_LIST_SUCCESS = 'basis/group/APPROVAL_LIST_SUCCESS';
const APPROVAL_LIST_FAILURE = 'basis/group/APPROVAL_LIST_FAILURE';

//# 승인처리 / 취소 처리
const APPROVAL_UPDATE_REQUEST = 'basis/group/APPROVAL_UPDATE_REQUEST';
const APPROVAL_UPDATE_SUCCESS = 'basis/group/APPROVAL_UPDATE_SUCCESS';
const APPROVAL_UPDATE_FAILURE = 'basis/group/APPROVAL_UPDATE_FAILURE';

//# 그룹사용자 조회
const USER_LIST_REQUEST = 'basis/group/USER_LIST_REQUEST';
const USER_LIST_SUCCESS = 'basis/group/USER_LIST_SUCCESS';
const USER_LIST_FAILURE = 'basis/group/USER_LIST_FAILURE';

//# 사용자 권한 수정 / 블럭 처리
const USER_UPDATE_REQUEST = 'basis/group/USER_UPDATE_REQUEST';
const USER_UPDATE_SUCCESS = 'basis/group/USER_UPDATE_SUCCESS';
const USER_UPDATE_FAILURE = 'basis/group/USER_UPDATE_FAILURE';

//# 그룹장 권한 위임
const USER_DELEGATE_REQUEST = 'basis/group/USER_DELEGATE_REQUEST';
const USER_DELEGATE_SUCCESS = 'basis/group/USER_DELEGATE_SUCCESS';
const USER_DELEGATE_FAILURE = 'basis/group/USER_DELEGATE_FAILURE';

const GROUP_MAIN_LIST_REQUEST = 'basis/group/GROUP_MAIN_LIST_REQUEST';
const GROUP_MAIN_LIST_SUCCESS = 'basis/group/GROUP_MAIN_LIST_SUCCESS';
const GROUP_MAIN_LIST_FAILURE = 'basis/group/GROUP_MAIN_LIST_FAILURE';

//그룹 선택
const SELECT_GROUP = 'basis/group/SELECT_GROUP';
const APRV_GROUP_SELECT = 'basis/group/APRV_GROUP_SELECT';
const USER_GROUP_SELECT = 'basis/group/USER_GROUP_SELECT';

export const MY_LIST = createAsyncAction(
  MY_LIST_REQUEST,
  MY_LIST_SUCCESS,
  MY_LIST_FAILURE
)<string, { data: GroupData[]; count: number }, AxiosError>();

export const JOIN_LIST = createAsyncAction(
  JOIN_LIST_REQUEST,
  JOIN_LIST_SUCCESS,
  JOIN_LIST_FAILURE
)<string, { data: JoinGroupData[]; count: number }, AxiosError>();

export const GROUP_MYLIST = createAsyncAction(
  GROUP_MYLIST_REQUEST,
  GROUP_MYLIST_SUCCESS,
  GROUP_MYLIST_FAILURE
)<string, { data: JoinGroupData[]; count: number }, AxiosError>();

export const GROUP_MAIN_LIST = createAsyncAction(
  GROUP_MAIN_LIST_REQUEST,
  GROUP_MAIN_LIST_SUCCESS,
  GROUP_MAIN_LIST_FAILURE
)<string, { data: MainGroupData[]; count: number }, AxiosError>();

export const GROUP_DETAIL = createAsyncAction(
  GROUP_DETAIL_REQUEST,
  GROUP_DETAIL_SUCCESS,
  GROUP_DETAIL_FAILURE
)<string, GroupData, AxiosError>();

export const GROUP_CREATE = createAsyncAction(
  GROUP_CREATE_REQUEST,
  GROUP_CREATE_SUCCESS,
  GROUP_CREATE_FAILURE
)<GroupData, string, AxiosError>();
export const GROUP_UPDATE = createAsyncAction(
  GROUP_UPDATE_REQUEST,
  GROUP_UPDATE_SUCCESS,
  GROUP_UPDATE_FAILURE
)<GroupData, String, AxiosError>();
export const GROUP_DELETE = createAsyncAction(
  GROUP_DELETE_REQUEST,
  GROUP_DELETE_SUCCESS,
  GROUP_DELETE_FAILURE
)<string, string, AxiosError>();

export const GROUP_LIST = createAsyncAction(
  GROUP_LIST_REQUEST,
  GROUP_LIST_SUCCESS,
  GROUP_LIST_FAILURE
  // )<GroupState, { data: GroupData[]; count: number }, AxiosError>();
)<string, { data: GroupData[]; count: number }, AxiosError>();

export const GROUP_CREATEID = createAsyncAction(
  GROUP_CREATEID_REQUEST,
  GROUP_CREATEID_SUCCESS,
  GROUP_CREATEID_FAILURE
)<void, string, AxiosError>();

export const GROUP_JOINLIST = createAsyncAction(
  GROUP_JOINLIST_REQUEST,
  GROUP_JOINLIST_SUCCESS,
  GROUP_JOINLIST_FAILURE
)<GroupState, { data: JoinGroupData[]; count: number }, AxiosError>();

export const GROUP_JOIN = createAsyncAction(
  GROUP_JOIN_REQUEST,
  GROUP_JOIN_SUCCESS,
  GROUP_JOIN_FAILURE
)<JoinGroupData, string, AxiosError>();

export const GROUP_JOIN_UPDATE = createAsyncAction(
  GROUP_JOIN_UPDATE_REQUEST,
  GROUP_JOIN_UPDATE_SUCCESS,
  GROUP_JOIN_UPDATE_FAILURE
)<JoinGroupData, string, AxiosError>();

export const APPROVAL_LIST = createAsyncAction(
  APPROVAL_LIST_REQUEST,
  APPROVAL_LIST_SUCCESS,
  APPROVAL_LIST_FAILURE
)<
  GroupState,
  { data: AprvGroupData[]; count: number; total: number },
  AxiosError
>();

export const APPROVAL_UPDATE = createAsyncAction(
  APPROVAL_UPDATE_REQUEST,
  APPROVAL_UPDATE_SUCCESS,
  APPROVAL_UPDATE_FAILURE
)<AprvGroupData, string, AxiosError>();

export const USER_LIST = createAsyncAction(
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAILURE
)<
  GroupState,
  { data: UserGroupData[]; count: number; total: number },
  AxiosError
>();

export const USER_UPDATE = createAsyncAction(
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILURE
)<UserGroupData, string, AxiosError>();

export const USER_DELEGATE = createAsyncAction(
  USER_DELEGATE_REQUEST,
  USER_DELEGATE_SUCCESS,
  USER_DELEGATE_FAILURE
)<UserGroupState, string, AxiosError>();

export const SELECT = createAction(SELECT_GROUP)<SelectData>();
export const GROUP_APRV_SELECT = createAction(APRV_GROUP_SELECT)<SelectData>();
export const GROUP_USER_SELECT = createAction(USER_GROUP_SELECT)<SelectData>();

const actions = {
  MY_LIST,
  JOIN_LIST,
  GROUP_DETAIL,
  GROUP_CREATE,
  GROUP_UPDATE,
  GROUP_DELETE,
  GROUP_LIST,
  GROUP_CREATEID,
  GROUP_JOINLIST,
  GROUP_JOIN,
  GROUP_JOIN_UPDATE,
  APPROVAL_LIST,
  APPROVAL_UPDATE,
  USER_LIST,
  USER_UPDATE,
  USER_DELEGATE,
  GROUP_MYLIST,
  GROUP_MAIN_LIST,

  SELECT,
  GROUP_APRV_SELECT,
  GROUP_USER_SELECT
};

export type GroupAction = ActionType<typeof actions>;
